<template>
    <div class="menu-item">
      <!-- <p @dblclick="$router.push({name: 'SingleContent', params: {id: customItem.content_id}})"> -->
		<p @click="showDetails ? showDetails = false : showDetails = true">
			{{ customItem.name[lang] ? customItem.name[lang] : '' }}
			<i style="position: absolute; right: 0; cursor: pointer; padding-right: 3px" :class="showDetails ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
		</p>
		<div v-if="showDetails" class="details-card">
			<div v-for="(value, key, index) in languages" style="text-align: left">
				<small> {{value}} </small>
				<br>
				<input v-model="selectedItem.name[key]">
			</div>
			<br>
			<small> {{selectedItem.url ? 'Url' : 'Original content'}} </small>
			<br>
			<input v-if="selectedItem.url" v-model="selectedItem.url">
			<input v-else disabled v-model="selectedItem.original">
			<div style="text-align: right">
				<el-button style="text-align: right" size="small" plain @click="handleSelect"> Save </el-button>
			</div>
   		</div>

    </div>
</template>

<script>
import InputField from "@/components/Inputs/InputField";
import { success, warning } from "../Notification/notification";
import { mapGetters } from "vuex";
import { firstToUpper } from "@/helpers/helpers";
import model from "@/model/index";

export default {
  props: ["item", "node", "lang"],
  components: {
    InputField,
  },
  computed: {
    ...mapGetters({
      contents: "getContents"
    }),
    languages () {
      return model.getLanguages();
    }
  },
  data() {
    return {
      regularItem: {},
      customItem: {
        url: "",
        name: {},
        id: undefined
      },
      error: "",
      isContents: true,
      loading: true,
      selectedItem: null,
      showNode: false,
      showDetails: false,
    };
  },
  async created () {    
    this.node
      ? this.keepItemData()
      : (this.selectedItem = null);

      this.loading = false
  },
  watch: {
    selectedItem () {
      this.keepItemData()
    },
    lang (data) {
      
    }
  },
  methods: {
    firstToUpper,
    warning,
    handleSelect() {
	  this.$emit("selectedContent", this.selectedItem);
	  this.showDetails = false
    },
    keepItemData () {
        this.customItem = this.node.data;
		this.selectedItem = this.customItem
		
		if (this.selectedItem.content_id) {
			for (let section of this.contents) {
				if (this.selectedItem.content_id === section.id) {
					this.selectedItem.original = section.title.en
				}
			}
		}

    },
  }
};
</script>

<style scoped>
.menu-item {
	transition-property: height;
}
small {
	margin-bottom: 10px;
}

input {
	width: 300px;
	padding: 10px;
	border-radius: 4px;
	border: 1px solid lightgrey;
	margin-bottom: 5px;
}
  
  
p {
  width: 325px;
  padding: 10px;
  border: 1px solid lightgrey;
  border-radius: 3px;
  cursor: move;
  margin-bottom: 5px;
  position: relative;
}

.details-card {
	background-color: whitesmoke;
	border-radius: 5px;
	padding: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/MenuItems/SingleMenuItem.vue